import { AbCampaignApiPath } from '@/common/api/params/abCampaign'
import { AiTagApiPath } from '@/common/api/params/aiTag'
import { AnalyticsApiPath } from '@/common/api/params/analytics'
import { ArticleApiPath } from '@/common/api/params/article'
import { ArticleApprovalApiPath } from '@/common/api/params/articleApproval'
import { AuditLogApiPath } from '@/common/api/params/auditLog'
import { AuthApiPath } from '@/common/api/params/auth'
import { BehaviorLogApiPath } from '@/common/api/params/behaviorLog'
import { BillingApiPath } from '@/common/api/params/billing'
import { ChatContextApiPath } from '@/common/api/params/chatContext'
import { CitationApiPath } from '@/common/api/params/citation'
import { CompetitorApiPath } from '@/common/api/params/competitor'
import { CompetitorSerpApiPath } from '@/common/api/params/competitorSerp'
import { CustomerApiPath } from '@/common/api/params/customer'
import { FeatureListApiPath } from '@/common/api/params/featureList'
import { FeatureRewriteApiPath } from '@/common/api/params/featureRewrite'
import { FtpSettingsApiPath } from '@/common/api/params/ftpSettings'
import { GscApiPath } from '@/common/api/params/gsc'
import { LinkageApiKeyApiPath } from '@/common/api/params/linkageApiKey'
import { LlmoApiPath } from '@/common/api/params/llmo'
import { MailTrackingApiPath } from '@/common/api/params/mailTracking'
import { MeApiPath } from '@/common/api/params/me'
import { MediaAnalysisTargetApiPath } from '@/common/api/params/mediaAnalysisTarget'
import { MediaDriverApiPath } from '@/common/api/params/mediaDriver'
import { NotificationApiPath } from '@/common/api/params/notification'
import { NotificationSettingsApiPath } from '@/common/api/params/notificationSettings'
import { OperatorApiPath } from '@/common/api/params/operator'
import { OrderHistoryApiPath } from '@/common/api/params/orderHistory'
import { PageRankingsApiPath } from '@/common/api/params/pageRankings'
import { PermissionTemplateApiPath } from '@/common/api/params/permissionTemplate'
import { PortalApiPath } from '@/common/api/params/portal'
import { RecommendationApiPath } from '@/common/api/params/recommendation'
import { RecommendationDistributionApiPath } from '@/common/api/params/recommendationDistribution'
import { RelayApiPath } from '@/common/api/params/relay'
import { RetrainApiPath } from '@/common/api/params/retrain'
import { SiteApiPath } from '@/common/api/params/site'
import { SiteOperatorApiPath } from '@/common/api/params/siteOperator'
import { SystemConfigApiPath } from '@/common/api/params/systemConfig'
import { TrackApiPath } from '@/common/api/params/track'
import { UgcApiPath } from '@/common/api/params/ugc'
import { UploadApiPath } from '@/common/api/params/upload'
import { W2MasterApiPath } from '@/common/api/params/w2Master'
import { WidgetApiPath } from '@/common/api/params/widget'
import { WidgetPageApiPath } from '@/common/api/params/widgetPage'

export const ApiPath = {
  ...AuthApiPath,
  ...OperatorApiPath,
  ...SiteOperatorApiPath,
  ...MeApiPath,
  ...PermissionTemplateApiPath,
  ...LinkageApiKeyApiPath,
  ...RecommendationApiPath,
  ...RecommendationDistributionApiPath,
  ...AnalyticsApiPath,
  ...RetrainApiPath,
  ...FeatureListApiPath,
  ...SiteApiPath,
  ...OrderHistoryApiPath,
  ...WidgetApiPath,
  ...WidgetPageApiPath,
  ...TrackApiPath,
  ...BehaviorLogApiPath,
  ...PageRankingsApiPath,
  ...CustomerApiPath,
  ...AbCampaignApiPath,
  ...UploadApiPath,
  ...RelayApiPath,
  ...FtpSettingsApiPath,
  ...NotificationSettingsApiPath,
  ...SystemConfigApiPath,
  ...W2MasterApiPath,
  ...MailTrackingApiPath,
  ...AiTagApiPath,
  ...FeatureRewriteApiPath,
  ...ArticleApiPath,
  ...ArticleApprovalApiPath,
  ...NotificationApiPath,
  ...MediaDriverApiPath,
  ...MediaAnalysisTargetApiPath,
  ...CompetitorApiPath,
  ...GscApiPath,
  ...CitationApiPath,
  ...LlmoApiPath,
  ...CompetitorSerpApiPath,
  ...UgcApiPath,
  ...BillingApiPath,
  ...AuditLogApiPath,
  ...ChatContextApiPath,
  ...PortalApiPath
}

export type ApiPath = (typeof ApiPath)[keyof typeof ApiPath]
